import { CustomerLookupContract } from 'models'

export const printCustomerName = (
    cus: CustomerLookupContract | undefined,
): string => {
    if (cus) {
        return `${cus.givenName ?? ''} ${cus.familyName ?? ''} ${
            cus.preferredName ? '(' + cus.preferredName + ')' : ''
        }`
    }
    return '-'
}
